import { useState, useEffect } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

interface ProfileAvatarProps {
  src?: string | null;
  alt: string;
  fallback: string;
  className?: string;
}

export const ProfileAvatar = ({ src, alt, fallback, className }: ProfileAvatarProps) => {
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    // Only show fallback after 1 second if image hasn't loaded
    const timer = setTimeout(() => {
      if (!src) {
        setShowFallback(true);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [src]);

  return (
    <Avatar className={className}>
      {src && (
        <AvatarImage
          src={src}
          alt={alt}
          className="object-cover"
          onError={() => setShowFallback(true)}
        />
      )}
      {showFallback && (
        <AvatarFallback className="bg-muted text-xs">
          {fallback}
        </AvatarFallback>
      )}
    </Avatar>
  );
};
